
export const newMainCategories = [
	'mainCategory1',
	'mainCategory2',
	'mainCategory3',
	'mainCategory4',
	'mainCategory5',
	'mainCategory6',
	'mainCategory7',
	'mainCategory8'
];
